"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TandCAcceptanceStatusContainerComponent = TandCAcceptanceStatusContainerComponent;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Actions = __importStar(require("./actions"));
const search_filter_component_1 = require("./search-filter-component");
const result_component_1 = require("./result-component");
function TandCAcceptanceStatusContainerComponent(props) {
    return (React.createElement(Elements.ScrollContainer, null,
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(Elements.H2, null, "T&C Acceptance Status")),
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(Elements.Label, null, "Acceptance Status"))),
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(search_filter_component_1.SearchFilterComponent, { filterItemsStates: props.filterItemsState, dispatch: props.dispatch })),
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement("div", null,
                React.createElement(Elements.StandardButton, { disabled: !isSearchable(props), onClick: () => props.dispatch(Actions.ShowResult()) }, "Search"))),
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(ResultView, Object.assign({}, props)))));
}
function isSearchable(_props) {
    return true;
}
function ResultView(props) {
    if (!props.showResults) {
        return null;
    }
    return React.createElement(result_component_1.ResultComponent, { searchSelections: props.searchSelections });
}
//# sourceMappingURL=container-component.js.map